import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

import { NotificationEvents } from './events';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Injectable()
export class NotificationAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'task';

  public getNotifications(category: string = null) {
    const request = 'getTasks';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_TASK_APISYNC_URL, this.controller, request);
    const data = { category: category };

    return this._apiService.get<app.models.NotificationModel[]>(url, data);
  }

  public getNumberOfNotifications() {
    const request = 'getNumberOfNotifications';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_TASK_APISYNC_URL, this.controller, request);

    return this._apiService.get<number>(url);
  }

  public markNotificationsAsRead(notificationIds: string[]) {
    const request = 'markNotificationsAsRead';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_TASK_APISYNC_URL, this.controller, request);
    const data = { notificationIds: notificationIds };

    return this._apiService.postAsync<app.models.ServerResponseModel>(url, data, [
      NotificationEvents.NotificationsMarkedAsRead,
    ]);
  }
}
